<script setup lang="ts">
import { provide, ref, watch } from 'vue';
import { createTabsRegistry } from './useTabsRegistry';
import { tabsRegistryKey } from './internal';

const props = defineProps<{ selectedId?: string }>();
const emit = defineEmits<{ 'update:selectedId': [id: string | undefined] }>();

const selectedId = ref<string | undefined>(props.selectedId);
// Keep the local selection in sync if the parent drives it via v-model.
watch(
  () => props.selectedId,
  (next) => {
    if (next !== undefined && next !== selectedId.value) selectedId.value = next;
  }
);

// Registry is type-erased here; panels supply the real metadata type T, and
// consumers re-pin it through defineTabs<T>() / useTabs<T>().
const registry = createTabsRegistry<unknown>({
  selectedId,
  onSelect: (id) => {
    selectedId.value = id;
    emit('update:selectedId', id);
  },
});
provide(tabsRegistryKey, registry);
</script>

<template>
  <div class="nx-tabs-v2">
    <slot />
  </div>
</template>

<style scoped>
.nx-tabs-v2 {
  /* Match v1 NxTabs: shrink within a constrained flex parent so panels scroll
     internally; size to content in an unconstrained parent. */
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  width: 100%;
}
</style>
